import { RefObject, useEffect, useRef, useState } from 'react';

// https://usehooks.com/useHover/
export function useHover(): [ref: RefObject<any>, value: boolean] {
  const [value, setValue] = useState(false);

  const ref: RefObject<HTMLElement> = useRef<HTMLElement>(null);

  const handleMouseOver = () => setValue(true);
  const handleMouseOut = () => setValue(false);

  useEffect(
    () => {
      const node: HTMLElement | null = ref?.current;
      if (node) {
        node.addEventListener('mouseenter', handleMouseOver);
        node.addEventListener('mouseleave', handleMouseOut);

        return () => {
          node.removeEventListener('mouseenter', handleMouseOver);
          node.removeEventListener('mouseleave', handleMouseOut);
        };
      }
    },
    [] // Recall only if ref changes
  );

  return [ref, value];
}
